import FitButtons from '../Components/FitButton';
import { RiInformationFill } from 'react-icons/ri';
import { useState } from 'react';
import { Currencies } from '../Components/Currencies';
import axios from 'axios';
import ReactLoading from 'react-loading';
import { getToken, windowReload } from '../utils';
import { toast } from 'react-toastify';

const formData = {
  account_type_id: '',
  bank_name: '',
  account_number: '',
  currency_id: '',
  country_id: '',
  active: '',
};

export const FormFieldLocal = (props) => {
  const { token: userToken } = getToken();

  const [inputs, setInputs] = useState(formData);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const { currencys, countrys, accountTypes } = Currencies();

  const handleChange = (e) => {
    const target = e.target;
    const { value, name } = target;
    setInputs((input) => ({
      ...input,
      [name]: value,
    }));
  };
  const allInputs = [
    {
      id: 1,
      label: 'Bank name',
      type: 'text',
      name: 'bank_name',
      value: inputs.bank_name,
      onchange: handleChange,
    },

    {
      id: 2,
      label: 'Account number',
      type: 'number',
      name: 'account_number',
      value: inputs.account_number,
      onchange: handleChange,
    },
    {
      id: 3,
      label: 'Account location',
      name: 'country_id',
      value: inputs.country_id,
      option: countrys,
      onchange: handleChange,
    },

    {
      id: 4,
      label: 'Account Currency',
      name: 'currency_id',
      value: inputs.currency_id,
      option: currencys,
      onchange: handleChange,
    },
    {
      id: 5,
      label: 'Account type',
      name: 'account_type_id',
      value: inputs.account_type_id,
      option: accountTypes,
      onchange: handleChange,
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsSubmiting(true);
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/local-accounts/store`,
        inputs,

        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );

      setInputs(formData);
      props.toggleAddAccountForm();
      toast.success('Accont successfully added');
      windowReload();
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setIsSubmiting(false);
    }
  };

  return (
    <section className='w-full flex flex-col gap-16 px-6 py-8 drop-shadow-lg bg-p-wh rounded mx-auto'>
      <div className='flex flex-row gap-2 text-s-bk bg-b-mct px-4 py-4 rounded-lg'>
        <span className='text-2xl'>
          <RiInformationFill />
        </span>
        <p className='text-sm'>
          This payment method will be use for transacting in Loyaltyview.
          Therefore while filling the form ensure that the information is
          correct, active, and matches your KYC information you provided
        </p>
        \
      </div>
      <form className='w-full flex flex-col gap-16' onSubmit={handleSubmit}>
        <div className='w-full gap-8 grid sm:grid-cols-2'>
          {allInputs.map((data) => (
            <div
              className=' w-full flex flex-col gap-2 col-span-1'
              key={data.id}
            >
              <label className='text-p-bk text-base font-pin relative'>
                {data.label}
              </label>
              {data.option ? (
                <select
                  type={data.type}
                  name={data.name}
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-14 px-4 rounded-lg'
                  value={data.value}
                  onChange={data.onchange}
                  required
                >
                  <option className='py-8'>. . . . Select . . . .</option>
                  {data?.option?.map((option) => (
                    <option className='py-8' key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={data.type}
                  name={data.name}
                  className='py-2 absolut focus:outline-none border-t-bk border-[1px] focus:ring focus:b-mc w-full h-14 px-4 rounded-lg'
                  value={data.value}
                  onChange={data.onchange}
                  required
                />
              )}
            </div>
          ))}
        </div>
        <div className='flex flex-row gap-6'>
          <button
            className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-2 md:px-8 py-2.5 w-fit font-semibold disabled:bg-b-mct bg-b-mc rounded-md'
            disabled={isSubmiting}
          >
            {!isSubmiting ? (
              '  + Add bank account'
            ) : (
              <ReactLoading
                type='cylon'
                color='#FFFFFF'
                height={44}
                width={44}
                className=''
              />
            )}
          </button>
          <FitButtons
            details='Cancel'
            color='cancel'
            icon={false}
            onClick={props.toggleAddAccountForm}
          />
        </div>
      </form>
    </section>
  );
};
